var site = site || {};
var generic = generic || {};

(function ($) {
  Drupal.behaviors.productShareV1 = {
    attach: function (context, settings) {
      var product_data = page_data['catalog-spp'].products[0];
      var $facebookShare = $('.product-full__share__facebook', context);
      var $twitterShare = $('.product-full__share__twitter', context);
      var $pinterestShare = $('.product-full__share__pinterest', context);
      var $add_to_favorites = $('.product-full__share-button--favorite', context);
      var shareText = (site.translations.product.share_description_text || '').replace('::product::', product_data.PROD_RGN_NAME);

      $facebookShare.once().on('click', function () {
        var facebook_title = encodeURIComponent(product_data.PROD_RGN_NAME);
        var facebook_url = encodeURIComponent(window.location.href);
        var facebook_full = 'https://www.facebook.com/sharer/sharer.php?u=' + facebook_url + '&t=' + facebook_title;

        window.open(facebook_full, 'facebook_share', 'width=790, height=460');
        applySocialMediaOffer($(this).data('offer-code'));
      });

      $pinterestShare.once().on('click', function () {
        var pinterest_url = encodeURIComponent(window.location.href);
        var pinterest_media = encodeURIComponent(window.location.origin + $('.product-full__image img').attr('src'));
        var pinterest_description = shareText;
        var pinterest_full_link = 'https://www.pinterest.com/pin/create/button/?url=' + pinterest_url + '&media=' + pinterest_media + '&description=' + pinterest_description;

        window.open(pinterest_full_link, 'pinterest', 'width=790, height=592');
        applySocialMediaOffer($(this).data('offer-code'));
      });

      $twitterShare.once().on('click', function () {
        var twitter_title = encodeURIComponent(product_data.PROD_RGN_NAME);
        var twitter_url = encodeURIComponent(window.location.href);
        var twitter_full = 'https://twitter.com/share/?text=' + shareText + '&url=' + twitter_url;

        window.open(twitter_full, 'tweet', 'width=790,height=460');
        applySocialMediaOffer($(this).data('offer-code'));
      });

      var applySocialMediaOffer = function (offerCode) {
        var signedIn = site.userInfoCookie.getValue('signed_in');
        var isLoyaltyMember = site.userInfoCookie.getValue('is_loyalty_member');

        // if the user is signed in and a loyalty member apply the social media offer
        if (signedIn && isLoyaltyMember) {
          var paramObj = {
            'offer_code': offerCode,
            'do_not_defer_messages': 1
          };

          generic.jsonrpc.fetch({
            method: 'offers.apply',
            params: [paramObj]
          });
        }
      };
    }
  };
})(jQuery);
